import React from 'react'
import { StyledNumberForm } from './styles'

const FormNumber = React.forwardRef(({ placeholder, onChangeVal, isDecimal, fractionDigits, ...rest }, ref) => {
  function handleKeyPress(event) {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    // different regex depending on whether decimal values are allowed
    const regex = isDecimal ? /^[0-9.]*$/ : /^[0-9]*$/; 

    // prevent entering input that doesn't not match the regex
    if (!regex.test(keyValue)) {
      event.preventDefault();
    }

    // prevent entering more than one decimal point
    if (isDecimal && keyValue === '.') {
      const value = event.target.value;
      if (value.indexOf('.') !== -1 || value === '') {
        event.preventDefault();
      }
    }
  }

  function handleChange(event) {
    const regex = isDecimal ? /^[0-9,.]*$/ : /^[0-9,]*$/;

    if (regex.test(event.target.value)) {
      const valueWithoutCommas = event.target.value.replace(/,/g, '');

      let parsedValue;
      if (valueWithoutCommas === '') {
        parsedValue = '';
      } else if (valueWithoutCommas.endsWith('.')) {
        parsedValue = valueWithoutCommas;
      } else {
        // restrict the number of decimal places if isDecimal true
        parsedValue = isDecimal ? parseFloat(valueWithoutCommas).toFixed(fractionDigits) : parseInt(valueWithoutCommas);
      }

      let formattedValue;
      if (parsedValue === '') {
        formattedValue = '';
      } else if (parsedValue.toString().endsWith('.')) {
        formattedValue = new Intl.NumberFormat('en-US').format(parsedValue) + '.';
      } else {
        formattedValue = new Intl.NumberFormat('en-US', {maximumFractionDigits: fractionDigits}).format(parsedValue);
      }
      
      onChangeVal(formattedValue);
    }
  }

  return (
    <StyledNumberForm
      placeholder={placeholder}
      ref={ref}
      onChange={e => handleChange(e)}
      onKeyPress={e => handleKeyPress(e)}
      {...rest}
    />
)})

export default FormNumber